module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-demo"
  }, _vm._l((_vm.navs), function(group) {
    return _c('div', {
      staticClass: "page-part"
    }, [_c('div', {
      staticClass: "page-title",
      domProps: {
        "textContent": _vm._s(group.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "page-part-swapper"
    }, [_c('mt-cell-group', _vm._l((group.list), function(item) {
      return _c('mt-cell', {
        key: item.path,
        attrs: {
          "to": item.path,
          "is-link": ""
        }
      }, [_c('div', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_c('i', {
        class: ['indexicon', 'icon-' + item.icon, 'mt-color-primary']
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])])
    }))], 1)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ae15f8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/demos.vue
// module id = 650
// module chunks = 0